import { useEffect } from "react";
const PIXEL_ID = "1252242806993118";
const PIXEL_SCRIPT_ID = "meta-pixel-script";
type FacebookPixel = ((...args: unknown[]) => void) & {
  loaded?: boolean;
  version?: string;
  queue: unknown[][];
  push?: FacebookPixel;
};
declare global {
  interface Window {
    fbq?: FacebookPixel;
    _fbq?: FacebookPixel;
  }
}
export function useMetaPixel() {
  useEffect(() => {
    if (!window.fbq) {
      const pixel = ((...args: unknown[]) => {
        pixel.queue.push(args);
      }) as FacebookPixel;
      pixel.queue = [];
      pixel.loaded = true;
      pixel.version = "2.0";
      pixel.push = pixel;
      window.fbq = pixel;
      window._fbq = pixel;
      if (!document.getElementById(PIXEL_SCRIPT_ID)) {
        const script = document.createElement("script");
        script.id = PIXEL_SCRIPT_ID;
        script.async = true;
        script.src = "https://connect.facebook.net/en_US/fbevents.js";
        document.head.appendChild(script);
      }
      window.fbq("init", PIXEL_ID);
    }
    window.fbq("track", "PageView");
  }, []);
}